module.exports = __webpack_public_path__ + "static/img/preview-gray-with-progress-bar.55403b1f.png";